import styled from "styled-components";
import SelectAutoWidth from "../../components/SelectAutoWidth";

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #fff;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 15px;
  padding-left: 8px;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: 18px;
  font-weight: 600;
  align-items: center;
  font-family: "Open Sans";
  line-height: 22px;
  color: #585f74;
  margin: 0;
`;

export const NewFlowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background-color: rgba(0, 34, 68, 1);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 150px;
  height: 34px;

  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  line-height: 25px;
  color: #ffffff;
  font-family: "Open Sans";
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 34, 68, 0.8);
  }
`;

export const FlowsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  padding: 10px;
  width: 100% !important;
`;

export const LeftHeaderContent = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 16px;
  // margin-bottom: 12px;
  margin-left: 12px;
  width: auto;
`;

export const FilterSelect = styled(SelectAutoWidth)`
  .ant-select-selector {
    border-radius: 10px !important;
    height: 40px !important;
    width: 100% !important;
    align-items: center !important;
  }

  .ant-select-selection-placeholder {
    color: black;
  }
`;

export const ShowMoreButton = styled.div`
  cursor: pointer;
  color: blue;
  width: 122px;
  height: 35px;
  font-size: 14px;
  background: rgba(17, 167, 217, 1);
  box-shadow: 0px 0.75px 1.5px 0px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  margin-top: 8px;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(17, 167, 217, 0.8);
  }
`;
